import format from 'date-fns/format';
import { t } from 'i18next';
import moment from 'moment';

export const eventDateDisplay = (eventStart: any) => {
	const createDate = (date: Date) => {
		const dd = String(date.getDate()).padStart(2, '0');
		const mm = String(date.getMonth() + 1).padStart(2, '0');
		const yyyy = date.getFullYear();

		const formatDate = dd + '.' + mm + '.' + yyyy;

		return formatDate;
	};

	const eventDate = format(eventStart, 'dd.MM.yyyy');
	const eventTime = moment(eventStart).format(' HH:mm');
	const today = new Date();
	const tommorow = new Date(today);
	tommorow.setDate(tommorow.getDate() + 1);

	return createDate(today) === eventDate
		? t('today') + eventTime
		: createDate(tommorow) === eventDate
		? t('tomorrow') + eventTime
		: format(eventStart, 'dd.MM.yyyy HH:mm ');
};
